import { render, staticRenderFns } from "./AdjustmentCreateNewComponent.vue?vue&type=template&id=063e1faa&scoped=true&"
import script from "./AdjustmentCreateNewComponent.vue?vue&type=script&lang=js&"
export * from "./AdjustmentCreateNewComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdjustmentCreateNewComponent.vue?vue&type=style&index=0&id=063e1faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e1faa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063e1faa')) {
      api.createRecord('063e1faa', component.options)
    } else {
      api.reload('063e1faa', component.options)
    }
    module.hot.accept("./AdjustmentCreateNewComponent.vue?vue&type=template&id=063e1faa&scoped=true&", function () {
      api.rerender('063e1faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/InvoiceAdjustmentRule/Modals/steps/AdjustmentCreateNewComponent.vue"
export default component.exports